var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("td", { staticClass: "col-cell pr-4 py-4 align-top" }, [
    _c(
      "span",
      {
        staticClass:
          "rounded-full border py-0.5 px-2 text-xs mx-0.5 mb-1 whitespace-no-wrap",
        class: _vm.chipClass,
      },
      [_vm._v(_vm._s(_vm.item))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }